import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSession } from '@/features/auth/useSession';

/**
 * Gate for routes that need a session.
 *
 * While the session is still resolving it renders a skeleton rather than
 * redirecting — bouncing a signed-in user to /login for the half-second before
 * `/auth/me` answers is the classic flash-of-logged-out bug.
 */
export function RequireAuth() {
  const { t } = useTranslation();
  const { isSignedIn, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <Stack spacing={2} aria-busy="true" aria-label={t('common.checkingSession')}>
        <Skeleton variant="rounded" height={44} width="40%" />
        <Skeleton variant="rounded" height={160} />
        <Skeleton variant="rounded" height={160} />
      </Stack>
    );
  }

  if (!isSignedIn) {
    // Remember where they were headed so signing in returns them there.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <Box>
      <Outlet />
    </Box>
  );
}
